import { formatMessage as f } from '@/i18n';

export const getKeyTypes = () => {
  return {
    // TODO: 这个文件需要重命名为KeyModes

    // HM
    userkey: f('key.type.unlock'),
    settingkey: f('key.type.set.lockid'),
    registerkey: f('key.type.set.secret'),
    emergencykey: f('key.type.emergency'),
    blacklistkey: f('key.type.black'),
    verifykey: f('key.type.get.lockid'),
    logoutkey: f('key.type.clear.secret'),
    blankkey: f('key.type.blank'),
    auditkey: f('key.type.record'),
    constructionkey: f('key.type.work'),
    tracekey: f('key.type.trace'),

    // WM
    0: f('key.type.blank'),
    9: f('key.type.emergency'),
    10: f('key.type.unlock'),
    16: f('key.type.record'),
    17: f('key.type.set.secret'),
    18: f('key.type.black'),
    19: f('key.type.get.lockid'),
    35: f('key.type.lock.direction'),
  };
};
